/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   2/28/22
 */

import React from "react";
import {FormControl, IconButton, InputLabel, MenuItem, Select, Stack, TextField, Tooltip} from "@mui/material";
import {CalendarView} from "../interfaces/Global";
import {useDispatch, useSelector} from "react-redux";
import {State} from "../state/store";
import DateRangePicker from "../components/DateRangePicker";
import {set} from "../state/reducers/range";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {addDays} from "date-fns";
import {format} from "../dates-helper";

export interface ViewToolbarProps {
	view: CalendarView
	setView: (view: CalendarView) => void
	day: Date
	setDay: (day: Date) => void
}

export default function ViewToolbar({ day, setDay, view, setView }: ViewToolbarProps) {

	const dispatch = useDispatch();
	const range = useSelector((s:State) => s.range);

	return (
		<Stack direction={"row"} spacing={2} sx={{ mr: 2 }}>
			{view === "month" &&
			<DateRangePicker
				range={range}
				onChange={(range) => {
					dispatch(set(range));
				}}
			/>}
			{view === "day" &&
			<Stack direction={"row"} spacing={2} alignItems={"center"}>
				<Tooltip title={"Previous day (" + format(addDays(day, -1), 'PPPP') + ")"}>
					<IconButton onClick={() => setDay(addDays(day, -1))}>
						<ArrowBackIcon />
					</IconButton>
				</Tooltip>
				<DatePicker
					label={"Day"}
					value={day}
					onChange={(value: any) => {
						if (value) {
							setDay(value);
						}
					}}
					renderInput={(params: any) =>
						<TextField
							sx={{ width: "140px" }}
							variant={"standard"}
							{...params}
						/>
					}
				/>
				<Tooltip title={"Next day (" + format(addDays(day, 1), 'PPPP') + ")"}>
					<IconButton onClick={() => setDay(addDays(day, 1))}>
						<ArrowForwardIcon />
					</IconButton>
				</Tooltip>
			</Stack>}
			<FormControl variant={"standard"} sx={{ width: 100 }}>
				<InputLabel>View</InputLabel>
				<Select
					value={view}
					onChange={event => {
						setView(event.target.value as CalendarView);
					}}
				>
					<MenuItem value={"month"}>Month</MenuItem>
					<MenuItem value={"day"}>Day</MenuItem>
				</Select>
			</FormControl>
		</Stack>
	);

}